export default {
      id: "top-shape-quote-usage",
      viewBox: "0 0 1243 85",
      url: "../../assets/" + "sprite.svg#top-shape-quote-usage",
      toString: function () {
        return this.url;
      }
    }